/** Routes where Qvara admins can scope lists by reseller (legacy route-switcher parity). */
export const RESELLER_CONTEXT_PATHS = [
  '/system/accounts',
  '/system/users',
  '/system/enterprises',
  '/system/api-keys',
  '/system/integrations',
  '/system/sip-credentials',
  '/billing/dashboard',
  '/billing/billed-rates',
  '/uc-admin/settings-and-security/music-on-hold',
  '/uc-admin/settings-and-security/captchas',
  '/uc-admin/settings-and-security/blocked-numbers',
  '/uc-admin/settings-and-security/recordings',
  '/uc-admin/call-flow/two-way-toggles',
  '/uc-admin/call-flow/multiway-toggles',
  '/uc-admin/call-flow/api-routers',
  '/uc-admin/call-flow/tag-routers',
  '/uc-admin/call-flow/call-queues',
  '/uc-admin/call-flow/ring-groups',
  '/uc-admin/call-flow/ivr-menus',
  '/uc-admin/call-flow/schedules',
  '/uc-admin/call-flow/vip-callers',
  '/uc-admin/extensions-and-devices/extensions',
  '/uc-admin/extensions-and-devices/phonebooks',
  '/uc-admin/extensions-and-devices/provisioning-devices',
  '/uc-admin/settings-and-security/webhooks',
  '/uc-admin/settings-and-security/star-codes',
  '/phone-numbers',
  '/uc-admin/phone-numbers',
  '/uc-admin/call-control-apps/automations',
  '/uc-admin/call-control-apps/call-parking-lots',
  '/uc-admin/call-control-apps/conference-bridges',
  '/uc-admin/call-control-apps/directories',
  '/uc-admin/call-control-apps/forwarders',
  '/uc-admin/call-control-apps/page-groups',
  '/uc-admin/call-control-apps/wakeup-calls',
  '/uc-user/automations',
  '/uc-user/blocked-numbers',
  '/uc-user/phonebooks',
  '/uc-user/call-flow-settings',
  '/uc-user/schedules',
  '/uc-user/extension-settings',
  '/uc-user/faxing',
  '/uc-user/messaging',
  '/reports/administrative/automations',
  '/reports/voice/call-history',
  '/reports/voice/ivr-analysis',
  '/reports/voice/missed-calls',
  '/reports/voice/extension-analysis',
  '/reports/voice/inbound-analysis',
  '/reports/voice/call-queue-analysis',
  '/reports/email-logs',
  '/reports/message-logs'
] as const

export const RESELLER_CONTEXT_QUERY_KEY = 'reseller_id'

export function isResellerContextPath(path: string): boolean {
  const normalized = path.split('?')[0]?.replace(/\/$/, '') || '/'
  return RESELLER_CONTEXT_PATHS.some((p) => normalized === p || normalized.startsWith(`${p}/`))
}
